import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { Popconfirm } from 'kts-components-antd-x4';
import { Button, AutoTableContainer, Table, message, Select, Drawer, Tag, PageHeaderFoot } from 'kts-xui';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import ModulesState from './Modules.State';
import { network, createCompany, tagmodule } from 'src/api';
import ModulesAction from './Modules.Action';
import ModalCompanyDetail from './UI.Network.Modal.CompanyDetail';
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    loading: any;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    public columns = [
        // {
        //     title: '序号',
        //     dataIndex: 'index',
        //     width: 180,
        // },
        {
            title: '公司名称',
            dataIndex: 'connectionName',
            width: 210,
            render: (text, record) => {
                return record.type === 1 ? record.connectionName : record.invitationCompanyName;
            }
        },
        {
            title: '纳税人识别号',
            dataIndex: 'connectionTaxId',
            width: 130
        },
        {
            title: '国家或地区',
            dataIndex: 'country',
            width: 100,
        },
        {
            title: '城市',
            dataIndex: 'city',
            width: 100,
        },
        // {
        //     title: '联系人',
        //     dataIndex: 'contractUser',
        //     width: 80,
        // }, 
        {
            title: '状态',
            dataIndex: 'connectionState',
            width: 80,
            render: (text, record) => {
                if (record.type === 2) {
                    return '已邮箱邀请';
                } else {
                    return text === 0 ? '已请求连接' :
                        text === 1 ? '已连接' :
                            text === 2 ? '已接受' :
                                text === 3 ? '待接受' : '';
                }
            }
        },
        {
            title: '操作',
            dataIndex: 'operate',
            width: 100,
            render: (text, record) => {
                /** 真实情况，此列表中只会存在 ，connectionState 为0和3的情况  */
                return (
                    <div>
                        { record.type === 1 && <a onClick={this.onShowCompanyDetailModal.bind(this, record.connectionId, record.connectionState === 3 ? record.connectionId : '')} >查看 </a>}
                        {
                            record.type === 2 ? (<div><a onClick={this.onReInvitation.bind(this, record)} >邀请 </a>
                                <Popconfirm
                                    title={
                                        <div>
                                            <div> 您是否确定取消发送给该公司的邮件邀请？</div>
                                            <div className={`${css.smtips}`}> 取消邮件邀请，之前发送给该公司的ticket将失效。</div>
                                        </div>
                                    }
                                    onConfirm={this.onCancelReInvitation.bind(this, record)}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <a>取消</a>
                                </Popconfirm>
                            </div>) :
                                record.connectionState === 0 ? <a onClick={this.onReRelation.bind(this, record)} >连接</a> :
                                    record.connectionState === 1 ? <a onClick={this.onCancelRelation.bind(this, record)} >取消连接</a> :
                                        record.connectionState === 3 ? <a onClick={this.onAcceptRelation.bind(this, record)} >接受</a> : ''
                        }
                    </div>
                );
            }
        }
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            pageMeta: null,
            list: [],
            params: {},
            viewDrawer: false
        };
    }
    componentDidMount() {
        // ModulesAction.initModulesStateWaitingJoinList();
        // ModulesAction.pageListWaitingJoinListAll(); 
        // ModulesAction.pageListWaitingJoinList(1);
        const params = {
            pageNum: 1,
            pageSize: 10
        };
        this.getData(params);
    }

    /** 组件被卸载时，关闭右侧弹窗 */
    componentWillUnmount() {
        // ModulesAction.hideAside();
    }
    onPageChange = (pageNum, pageSize) => {
        this.setState({
            pageMeta: {
                ...this.state.pageMeta,
                pageNum,
                pageSize
            }
        }, () => {
            this.onRefresh();
        });
    }
    onRefresh = () => {
        const params = {
            ...this.state.params,
            ...this.state.pageMeta,
        };
        this.getData(params);
    }
    getData = async (params) => {
        let data = await network.networkWaitingJoinList(this, params);
        if (!data.er) {
            data.res = data.res.map((item, index) => {
                return {
                    ...item,
                    index
                };
            });
            this.setState({
                list: data.res
            });
            // this.modulesState.stateWaitingjoin.list = [];
            // this.modulesState.stateWaitingjoin.list = data.res.map((item, index) => {
            //     return {
            //         ...item,
            //         index
            //     };
            // });
            // this.modulesState.stateWaitingjoin.pagination.total = data.res.length;
            // this.modulesState.stateWaitingjoin.pagination.total = data.res.length;
            // this.setModulesState(this.modulesState);
        }
    }
    onCloseView = () => {
        this.setState({
            viewDrawer: false
        });
    }
    render() {
        const page = {
            defaultPageSize: 20,
        };
        const { pageMeta, list, viewDrawer } = this.state;
        return (


            <div style={{ height: 'calc(100vh - 140px)', display: 'flex', flexDirection: 'column' }}>
                {/* <div style={{ flex: 'none', position: 'relative', zIndex: 1 }} className="special">
                    <PageHeaderFoot
                        onRefresh={this.onRefresh}
                    >
                    </PageHeaderFoot>
                </div> */}
                <AutoTableContainer style={{ flex: 1,backgroundColor: 'white' }} >
                    <Table
                        className={css.special}
                        columns={this.columns}
                        bordered={true}
                        // pagination={false}
                        dataSource={list}
                        rowKey="index"
                    />
                </AutoTableContainer>
                {
                    viewDrawer &&
                    <Drawer
                        title='详情'
                        onClose={this.onCloseView}
                        visible={viewDrawer}
                        width={520}
                    >
                        <ModalCompanyDetail />
                    </Drawer>
                }
            </div>
        );
    }
    private loadMoreFunc = async () => {
        ModulesAction.pageListAdminWaitingJoinscroll();
    }
    /** 查看详情 */
    private onShowCompanyDetailModal = (companyId, Id) => {

        ModulesAction.networkWaitingCompayDetail(companyId, Id);
        this.setState({
            viewDrawer: true
        });
        // MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
        //     Components: <ModalCompanyDetail />,
        //     title: '详情'
        // });
    }
    /** 重新发送连接请求 */
    private onReRelation = (rec) => {
        ModulesAction.sendRelation({
            targetCompanyId: rec.connectionId,
            targetTaxId: rec.connectionTaxId
        });
    }
    /** 重新邀请 */
    private onReInvitation = (record) => {
        ModulesAction.invitOneCompany({
            invitationCompanyName: record.invitationCompanyName,
            invitationEmail: record.contactEmail
        });
    }
    /** 取消邀请 */
    private onCancelReInvitation = async (record) => {
        // ModulesAction.cancelInvite({ ticket: record.ticket });
        const params = { ticket: record.ticket };
        let res = await network.cancelNetworkInvite(this, params);
        if (!res.er) {
            if (!res.res) {
                message.error('取消邮件邀请失败');
            } else {
                message.success('成功取消邮件邀请');
                this.onRefresh();
            }
        }
    }
    /** 接受连接 */
    private onAcceptRelation = async (record) => {

        // ModulesAction.acceptRelation({
        //     connectCompanyId: record.connectionId
        // });
        const param = { connectCompanyId: record.connectionId }
        let res = await network.acceptNetworkRelation(this, param);
        if (!res.er) {
            if (!res.res) {
                message.error('发送邀请失败');
            } else {
                message.success('已建立连接');
                this.onRefresh();
            }
        }
    }
    /** 取消连接 */
    private onCancelRelation = () => {
        /**  */
        console.log('理论上，并不存在此操作的状态值');
    }
    /** 关闭右侧弹窗 */
    // private hideAside = () => {
    //     MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
    // }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Network.Admin.WaitingJoinList.tsx